
import {timestampToTime,timestampToDate} from '@/utils/timestamp'

// 时间戳转时间 过滤器
const toTime = (t)=>{
    return timestampToTime(t)
}

// 时间戳转日期 过滤器
const toDate = (t)=>{
    return timestampToDate(t)
}

// 字符串转数字 保留2位小数
const toFixed2 = (t)=>{
    return Number(t).toFixed(2)
}
// 字符串转数字 保留三位小数
const toFixed3 = (t)=>{
    return Number(t).toFixed(3)
}

// 字符串转数字 不补0
const toNumber = (t)=>{
    return Number(Number(t).toFixed(3))
}

// 补4个0
const addZero = (num)=>{
    if(String(num).length>4){
        return num
    }else{
        return (Array(4).join(0) + num).slice(-4);
    }
}
export default {
    toTime,
    toDate,
    toFixed2,
    toFixed3,
    toNumber,
    addZero
}